(() => {
  const pushEvent = (event, payload = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  };

  const getPriceElement = (priceSource) => {
    if (!priceSource) return null;
    return (
      priceSource.querySelector('.price--on-sale .price-item--sale') ||
      priceSource.querySelector('.price__regular .price-item--regular')
    );
  };

  const initMobileBuybar = (bar) => {
    const form = document.getElementById(bar.dataset.productFormId);
    const mainButton = form?.querySelector('[type="submit"]');
    const stickyButton = bar.querySelector('[data-ob-mobile-submit]');
    const stickyPrice = bar.querySelector('[data-ob-mobile-price]');
    const priceSource = document.getElementById(bar.dataset.priceSource);
    if (!form || !mainButton || !stickyButton) return;

    const sync = () => {
      const sourcePrice = getPriceElement(priceSource);
      if (sourcePrice && stickyPrice) stickyPrice.innerHTML = `<strong>${sourcePrice.textContent.trim()}</strong>`;
      const unavailable = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = unavailable;
      stickyButton.textContent = mainButton.querySelector('span:not(.sold-out-message)')?.textContent.trim() || mainButton.textContent.trim();
    };

    stickyButton.addEventListener('click', () => {
      pushEvent('ob_mobile_sticky_add_to_cart', { variant_id: form.querySelector('[name="id"]')?.value });
      mainButton.click();
    });

    new MutationObserver(sync).observe(form, { attributes: true, childList: true, subtree: true });
    if (priceSource) new MutationObserver(sync).observe(priceSource, { childList: true, subtree: true });

    new IntersectionObserver(
      ([entry]) => bar.classList.toggle('is-hidden', entry.isIntersecting),
      { threshold: 0.35 }
    ).observe(mainButton);
    sync();
  };

  const updateSelectionSummary = () => {
    const values = Array.from(document.querySelectorAll('variant-selects .ob-option-step'))
      .map((step) => {
        const checked = step.querySelector('input:checked');
        const select = step.querySelector('select');
        return checked?.value || select?.value;
      })
      .filter(Boolean);
    const summary = document.querySelector('[data-ob-selection-summary]');
    if (summary && values.length) summary.textContent = values.join(' · ');
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) updateSelectionSummary();
  });

  document.querySelectorAll('[data-ob-mobile-buybar]').forEach(initMobileBuybar);
  updateSelectionSummary();
})();
